import { Validator } from '../../types/Validator';

const NON_NUMERIC = /\W+/g;
const FORMAT = /^(\d){4}\s(\d){4}\s(\d){4}\s(\d){3,4}$/;

export const errorCode = 'INVALID_CREDIT_CARD';

export const creditCard: Validator<string | number> = (value?) => {
  if (value === undefined) return undefined;

  const cleanValue = toNumber(value);

  return !FORMAT.test(String(value)) || isZero(cleanValue) || !luhn(cleanValue)
    ? { errorCode }
    : undefined;
};

function toNumber(value?: string | number) {
  return String(value).replace(NON_NUMERIC, '');
}

function isZero(value: string) {
  return Number(value) === 0;
}

function luhn(creditCard: string): boolean {
  const numbers: number[] = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let len: number = creditCard.length;
  let numberOrValue = true;
  let sum = 0;
  let partialValue: number;

  while (len) {
    numberOrValue = !numberOrValue;
    partialValue = Number(creditCard.charAt(--len));
    sum += numberOrValue ? numbers[partialValue] : partialValue;
  }

  return Boolean(sum && sum % 10 === 0);
}
